<template>
  <div class="my-work-order">
    <div class="work-order-wrap">
      <div class="service-entry">
        <template v-if="!hasEntry">
          <div class="common-entry" @click="hasEntry = true">
            <img src="./images/service.png" alt="" />
            <div class="work-order-remind">
              <div v-if="newNoticeNum > 0"></div>
              <div v-if="newCustomerNoticeNum > 0"></div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="active-entry">
            <img src="./images/service-active.png" @click="closeEntryService" alt="" />
            <ul class="service-list">
              <li class="my-order order-item" @click="checkOrderList">
                <span>{{ $t('common.myWorkOrder') }}</span>
                <div class="remind-text" v-show="newNoticeNum > 0"></div>
              </li>
              <li class="my-service order-item" @click="openService">
                <span>{{ $t('common.myCustomerService') }}</span>
                <div v-if="newCustomerNoticeNum > 0"></div>
              </li>
            </ul>
            <div class="service-detail-list" v-if="orderListFlag">
              <OrderList :appType="appType" @closeMyOrderList="closeMyOrderList"/>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import OrderList from "./orderList.vue";
import YSF from "@neysf/qiyu-web-sdk";
import { queryWorkSheetUnReadCount, queryCustomerSheetUnReadCount, updateCustomerSheetRead } from "./apis";
export default {
  props: {
    appType: {
      type: String,
      default: 'agent',
    },
  },
  components: {
    OrderList,
  },

  data() {
    return {
      orderListFlag: false,
      hasEntry: false, // Whether clicked customer service entry
      pageIndex: 1, // Completed work order current page number
      pageSize: 10,
      newNoticeNum: 0,
      newCustomerNoticeNum: 0, // Customer service unread message count
      myOrderDialog: false, // My work order dialog
      qiyu: null, // QiYu customer service
      listData: [],
      dataCount: 0,
      activeName: "finished",
      orderDetialDialog: false,
      userInfo: {},
    };
  },
  computed: {
    // Check if is teacher type
    isTeacher() {
      return this.appType === 'teacher';
    },
    // Check if is agent type
    isAgent() {
      return this.appType === 'agent';
    },
    // Get user info storage key
    userInfoKey() {
      return this.isTeacher ? 'teacher_info' : `${this.appType}_user_info`;
    },
    // Get extra request params (teacher type needs type:1)
    extraParams() {
      return this.isTeacher ? { type: 1 } : {};
    },
  },
  methods: {
    // My work order count, parent to child
    closeMyOrderList(){
      this.orderListFlag= false
      this.queryWorkSheetUnReadCount()
    },
    // Click icon to close my customer service
    closeEntryService(){
        this.hasEntry = false
        this.orderListFlag = false
    },
    // View work order list
    checkOrderList() {
      this.orderListFlag = true;
    },
    getAgentInfo() {
      const userInfo = this.userInfo || {};
      const ssoCampusInfo = JSON.parse(localStorage.getItem('sso_campus_info') || '[]');

      // Get user ID
      const userId = ssoCampusInfo.length > 0 ? ssoCampusInfo[0].userId : '';
      const uid = userId || userInfo.id;

      // Get organization ID list
      const organizationIds = ssoCampusInfo.length > 0
        ? ssoCampusInfo.map(item => item.campusId)
        : [userInfo.campusId];

      // Get organization info
      const organizationId = userInfo.campusId;
      const organizationType = this.isAgent ? this.$t('common.dealer') : this.$t('common.agent');
      const organizationLevel = userInfo.position === 6008001 ? this.$t('common.mainAccount') : this.$t('common.subAccount');

      // Get user basic info
      const name = userInfo.trueName || '';
      const mobile = userInfo.mobile || '';

      return {
        uid,
        name,
        mobile,
        organizationId,
        organizationIds,
        organizationType,
        organizationLevel,
      };
    },
    getTeacherInfo () {
      const userInfo = this.userInfo || {};
      const ssoCampusInfo = userInfo.account_list || [];

      // Get user ID
      const uid = userInfo.teacher_id;
      // Get organization ID list
      const organizationIds = ssoCampusInfo.length > 0
        ? ssoCampusInfo.map(item => item.school_id)
        : [userInfo.school_id];

      // Get organization info
      const organizationId = userInfo.school_id;
      const organizationType = this.$t('common.analyst');
      const organizationLevel = '';

      // Get user basic info
      const accountInfo =
        JSON.parse(localStorage.getItem('account_list')) || {};
      const name = userInfo.real_name || '';
      const mobile = userInfo.phone || accountInfo.phone || '';

      return {
        uid,
        name,
        mobile,
        organizationId,
        organizationIds,
        organizationType,
        organizationLevel,
      };
    },
    // Initialize QiYu customer service
    initQiYu() {
      /**
       * First param: enterprise appkey
       * Second param: config params
       */
      const {
        uid, name, mobile,
        organizationId,
        organizationIds,
        organizationType,
        organizationLevel,
      } = this.isTeacher ? this.getTeacherInfo() : this.getAgentInfo();

      // Build base data
      const data = [
        { key: "key1", label: this.$t('common.auto_346_8759d587'), value: name },
        { key: "key2", label: this.$t('common.mobile'), value: mobile },
        {
          key: "key3",
          label: this.$t('app.auto_384_0c33fbe1'),
          value: organizationId,
        },
        {
          key: "key4",
          label: this.$t('app.auto_385_64f70ee4'),
          value: organizationType,
        },
        {
          key: "key5",
          label: this.$t('app.auto_386_bc3579ad'),
          value: organizationLevel,
        },
        {
          key: "key6",
          label: this.$t('app.auto_387_5f606fef'),
          value: organizationIds.toString(),
        },
      ];

      // If teacher account, add analyst account info
      if (this.isTeacher) {
        data.push({ key: "key7", label: this.$t('common.analystAccount'), value: this.userInfo.uname });
      }

      const options = {
        uid,
        data: JSON.stringify(data),
        layerSize: {
          width:650,
          height:650,
        }
      };
      return new Promise((resolve, reject) => {
        YSF.init("deb4cf6b9b8be27685aa179e7d86c16d", {
          hidden: 1,
        })
          .then((ysf) => {
            ysf("config", options);
            this.qiyu = ysf;
          })
          .catch((error) => {
            console.log("SDK load failed---", error);
            this.$message.error(this.$t('salesCenter.myServiceLoadFail'));
          })
          .finally(() => {
            resolve();
          });
      });
    },
    // Click my customer service to start conversation
    async openService() {
      if (!this.qiyu) {
        await this.initQiYu();
      }
      if (this.qiyu) {
        this.qiyu("open", {
          templateId: 4463292,
        });
        this.qiyu("onunread", (res) => {
          this.newCustomerNoticeNum = parseInt(res.total || 0);
        });
        this.updateCustomerSheetRead(); // Update customer service message read status
      }
    },
    // Get base request params
    getBaseParams() {
      const userId = this.userInfo[this.isTeacher ? 'teacher_id' : 'id'];
      return {
        param: { 
          userId,
          ...this.extraParams
        }
      };
    },
    // Handle API response
    handleApiResponse(response, callback) {
      if (response.code == 0 && callback) {
        callback(response.data);
      }
    },
    // Query work sheet unread count
    queryWorkSheetUnReadCount() {
      const params = this.getBaseParams();
      queryWorkSheetUnReadCount(params).then((res) => {
        this.handleApiResponse(res, (data) => {
          this.newNoticeNum = parseInt(data || 0);
        });
      });
    },
    // Query customer service unread count
    queryCustomerSheetUnReadCount() {
      const params = this.getBaseParams();
      queryCustomerSheetUnReadCount(params).then((res) => {
        this.handleApiResponse(res, (data) => {
          this.newCustomerNoticeNum = parseInt(data || 0);
        });
      });
    },
    updateCustomerSheetRead() {
      const params = this.getBaseParams();
      updateCustomerSheetRead(params).then((res) => {
        this.handleApiResponse(res, (data) => {
          this.newCustomerNoticeNum = 0;
        });
      });
    },
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem(this.userInfoKey) || '{}');
  },
  mounted() {
    this.queryWorkSheetUnReadCount();
    this.queryCustomerSheetUnReadCount();
  },
};
</script>

<style lang="scss" scoped>
.work-order-wrap {
  position: fixed;
  bottom: 40px;
  right: 24px;
  z-index: 100;
  .service-entry {
    img {
      display: block;
      width: 88px;
      height: 88px;
    }
    .common-entry {
      position: relative;
      .work-order-remind {
        position: absolute;
        display: block;
        top: 10px;
        left: -60px;
        .remind-text {
          height: 20px;
          line-height: 20px;
          padding: 0 12px;
          margin-bottom: 4px;
          font-size: 12px;
          color: #fff;
          background: #FF4A46;
          border-radius: 10px;
          &:first-child {
            border-bottom-right-radius: 0px;
          }
          &:last-child {
            border-top-right-radius: 0px;
          }
          &:only-child {
            border-bottom-right-radius: 0px;
            border-top-right-radius: 10px;
          }
        }
        .order-new {
          background: #FF4A46;
        }
        .service-new {
          background: #FFA500;
        }
      }
    }
    .active-entry {
      position: relative;
      .service-list {
        width: 188px;
        height: 152px;
        background: #ffffff;
        box-shadow: 0px 6px 12px 0px rgba(68, 75, 101, 0.12);
        border-radius: 18px;
        position: absolute;
        bottom: 18px;
        right: 108px;
        cursor: pointer;
        .order-item {
          height: 50%;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 22px;
          color: #333333;
          line-height: 30px;
          font-style: normal;
          .remind-text {
            position: absolute;
            right: 24px;
            top: 6px;
            height: 20px;
            line-height: 20px;
            padding: 0 12px;
            font-size: 12px;
            color: #fff;
            border-radius: 10px 10px 10px 0px;
            background: #FF4A46;
          }
        }
        .my-order .remind-text {
          background: #FF4A46;
        }
        .my-service .remind-text {
          background: #FFA500;
        }
      }
      .service-detail-list {
        position: absolute;
        bottom: 18px;
        right: 108px;
        width: 630px;
        background: #ffffff;
        box-shadow: 0px 6px 12px 0px rgba(68, 75, 101, 0.12);
        border-radius: 18px;
        padding: 16px;
      }
    }
  }
}
.my-order-wrap {
  // max-height: 50vh;
  // overflow-y: scroll;
  .order-list {
    .detail-edit-wrap {
      position: relative;

      .new-tip {
        position: absolute;
        width: 12px;
        height: 12px;
        background: #ff4757;
        border-radius: 50%;
        top: 10px;
      }
    }
  }
}
.order-detail-wrap {
  max-height: 50vh;
  overflow-y: scroll;
  padding: 0 30px;
  h3 {
    text-align: center;
    font-size: 16px;
  }
  .order-info {
    table {
      margin-top: 20px;
      tr {
        padding: 20px;
        height: 30px;
      }
      .tip {
        width: 240px;
      }
    }
  }
  .order-result {
    .text-wrap {
      margin-top: 20px;
    }
    .file-wrap {
      margin-top: 20px;
      padding: 0 30px;
      display: grid;
      grid-template-columns: repeat(3, 33%);
      .file-item {
        padding: 5px;
      }
    }
  }
}
</style>